/**
 * Status de um veículo / anúncio.
 *
 * Derivado de `app/constants/vehicle-status.constant.js` e
 * `app/constants/vehicle-status.enum.js` (constantes AngularJS `VEHICLE_STATUS`
 * e `VEHICLE_STATUS_ENUM`). Os valores são os `CODE` originais — o backend os
 * transporta como string, por isso o enum é de string para manter a
 * compatibilidade exata com o runtime híbrido.
 *
 * Observação: o status "todos ativos" (`ALLACTIVE`) tem `CODE: undefined` no
 * legado (significa "nenhum filtro de status"). Como um enum não representa
 * `undefined`, esse caso é modelado pela ausência de valor — use `undefined`
 * no parâmetro de filtro em vez de um membro do enum.
 */
export enum VehicleStatus {
  All = '9',
  Excluded = '-1',
  Available = '0',
  Sold = '1',
  Announced = '3',
  AnnouncedSuccess = '7',
  AnnouncedError = '8',
  Pending = '4',
  Reserved = '5',
  NoPicture = '6',
  PendingRestoreData = '10',
}

export const WEBSITE_ELIGIBLE_STATUSES: ReadonlySet<number> = new Set([
  Number(VehicleStatus.Available),
  Number(VehicleStatus.Announced),
  Number(VehicleStatus.Pending),
]);

/**
 * Chaves de tradução (i18n) associadas a cada status, conforme os `LABEL`
 * originais da constante AngularJS. Útil para exibir o status na UI.
 */
export const VEHICLE_STATUS_LABELS: Readonly<Record<VehicleStatus, string>> = {
  [VehicleStatus.All]: 'VEHICLE.VEHICLE_STATUS.ALL',
  [VehicleStatus.Excluded]: 'VEHICLE.VEHICLE_STATUS.EXCLUDED',
  [VehicleStatus.Available]: 'VEHICLE.VEHICLE_STATUS.AVAILABLE',
  [VehicleStatus.Sold]: 'VEHICLE.VEHICLE_STATUS.SOLD',
  [VehicleStatus.Announced]: 'VEHICLE.VEHICLE_STATUS.ANNOUNCED',
  [VehicleStatus.AnnouncedSuccess]: 'VEHICLE.VEHICLE_STATUS.ANNOUNCED_SUCCESS',
  [VehicleStatus.AnnouncedError]: 'VEHICLE.VEHICLE_STATUS.ANNOUNCED_ERROR',
  [VehicleStatus.Pending]: 'VEHICLE.VEHICLE_STATUS.PENDING',
  [VehicleStatus.Reserved]: 'VEHICLE.VEHICLE_STATUS.RESERVED',
  [VehicleStatus.NoPicture]: 'VEHICLE.VEHICLE_STATUS.NOPICTURE',
  [VehicleStatus.PendingRestoreData]: 'VEHICLE.VEHICLE_STATUS.PENDING_RESTORE_DATA',
};
